export const PROFILE_STATUS_CONFIG = {
    UNVERIFIED: {
        label: "Unverified",
        color: "#374151", bg: "#F9FAFB", border: "#E5E7EB", dot: "#9CA3AF",
        iconName: "solar:user-bold",
    },
    VERIFIED: {
        label: "Verified",
        color: "#065F46", bg: "#ECFDF5", border: "#A7F3D0", dot: "#10B981",
        iconName: "solar:verified-check-bold",
    },
    UPDATED: {
        label: "Updated",
        color: "#92400E", bg: "#FFFBEB", border: "#FDE68A", dot: "#F59E0B",
        iconName: "solar:refresh-bold",
    },
    PROFILE_REJECTED: {
        label: "Rejected",
        color: "#991B1B", bg: "#FFF1F2", border: "#FECDD3", dot: "#F43F5E",
        iconName: "solar:shield-slash-bold",
    },
    BLOCKED: {
        label: "Blocked",
        color: "#334155", bg: "#F1F5F9", border: "#CBD5E1", dot: "#64748B",
        iconName: "solar:forbidden-circle-bold",
    },
};
